import getSystemLanguage, { getLanguageJSON } from '../utils/LanguageUtils'

export default function useLanguage(changeLangTo = '') {

    let locale;
    if (changeLangTo === '')
        locale = getSystemLanguage();
    else
        locale = changeLangTo;

    return getLanguageJSON(locale)
}